import { Component, OnInit } from '@angular/core';
import { LifeCycles, registerApplication } from 'single-spa';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { PlatformCommunicatorAuthService } from 'src/app/shared/services/communicator/platform-communicator/platform-communicator.auth.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { PlatformEndpointService } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-micro-simulator',
  templateUrl: './micro-simulator.component.html',
  styleUrls: ['./micro-simulator.component.scss'],
})
export class MicroSimulatorComponent implements OnInit {
  authSso: any;
  controlFlow: any;
  functions: any;

  constructor(
    private headerService: HeaderService,
    private authService: PlatformCommunicatorAuthService,
    private navigationService: NavigationService,
    private loaderService: LoaderService,
    private abreCuentasService: AbreCuentasService,
    private endpointService: PlatformEndpointService,
    private channelCommunicatorService: ChannelCommunicatorService,
  ) {
    this.headerService.show(false, false, true);
    this.authSso = {
      session_id: this.authService.getSessionId(),
      token: this.authService.getSSOInformation().accessToken,
      transaction_id: this.abreCuentasService.getTransactionId(),
    };

    this.controlFlow = {
      nextStep: () => {
        this.loaderService.forceHide();
        this.navigationService.nextStep();
      },
      previousStep: () => this.navigationService.previousStep(),
    };

    this.functions = {
      otherSimulationData: (value: any) =>
        this.abreCuentasService.setOtherSimulationData(value),
      getIsLogin: () => this.abreCuentasService.getPostlogin(),
      downloadPdf: (value: any) =>
        this.channelCommunicatorService.getImpl().openPdf(value),
      backpage: () =>
        this.channelCommunicatorService.getImpl().redirectToLoginView(),
      channel: () => this.channelCommunicatorService.getChannelId(),
    };
  }

  ngOnInit() {
    registerApplication({
      name: 'simulator',
      app: (): Promise<LifeCycles> =>
        System.import(this.endpointService.MICROFRONTENDS.SIMULATOR),
      activeWhen: '/',
      customProps: {
        ssoProps: this.authSso,
        controls: this.controlFlow,
        loader: this.loaderService,
        functions: this.functions,
      },
    });
  }
}
